import { render, staticRenderFns } from "./ClassBodyTable.vue?vue&type=template&id=f73a376c&scoped=true&"
import script from "./ClassBodyTable.vue?vue&type=script&lang=js&"
export * from "./ClassBodyTable.vue?vue&type=script&lang=js&"
import style0 from "./ClassBodyTable.vue?vue&type=style&index=0&id=f73a376c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73a376c",
  null
  
)

export default component.exports